import { CircularProgress } from "components/Mui";

export default function GreenCircleLoading() {
  return <CircularProgress size={20} sx={{ color: "#54C081" }} thickness={5} />;
}
